const transformEventPreview = (event) => ({
  date: event.date,
  description: event.preview,
  eventId: event.shift_id,
  eventSlug: event.url_slug,
  isGda: event.is_global_dining_access,
  isPresale: event.is_presale,
  price: event.price_summary.min_str,
  responsiveImages: event.responsive_images,
  time: event.time,
  title: event.name,
  venueId: event.venue.id,
  venueName: event.venue.name,
  venueSlug: event.venue.url_slug,
  city: event.venue.location.code,
  photo: event.image_preview,
  maxPartySize: event.max_party_size,
});

export default transformEventPreview;
